export const importKeys = {
  all: ['brief-import'] as const,
  canvas: ({
    accountId,
    projectId,
    integration,
  }: {
    accountId: string
    projectId: string
    integration: string
  }) =>
    [...importKeys.all, 'canvas', accountId, projectId, integration] as const,
  campaigns: ({
    accountId,
    projectId,
    integration,
  }: {
    accountId: string
    projectId: string
    integration: string
  }) =>
    [
      ...importKeys.all,
      'campaigns',
      accountId,
      projectId,
      integration,
    ] as const,
  campaignDetail: ({
    accountId,
    projectId,
    integration,
    campaignId,
  }: {
    accountId: string
    projectId: string
    integration: string
    campaignId: string
  }) =>
    [
      ...importKeys.all,
      'campaign',
      accountId,
      projectId,
      integration,
      campaignId,
    ] as const,
}
